module.exports = __webpack_public_path__ + "static/media/telsa-image.832b80e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/telsa-image.png
// module id = 318
// module chunks = 0